import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";

const BlogCategory = (props) => {
  return (
    <div className="blog-category-box sticky-top">
      <div className="heading-box">
        <h2>Category</h2>
        <p>All the Blogs Category</p>
      </div>
      <ul>
        {props.categories?.map((cat, idx) => (
          <li key={idx}>
            <NavLink to={`category/${cat.name}`}>
              {cat.name.replaceAll("-", " ")}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BlogCategory;
